"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLogicalCombinationCondition = void 0;
const types_js_1 = require("./types.js");
const logicalCombinationOperatorExpression = {
    or: 'OR',
    and: 'AND'
};
const parseLogicalCombinationCondition = (conditionParser, condition) => {
    const logicalCombinationOperator = Object.keys(condition).find(types_js_1.isLogicalCombinationOperator);
    const childrenConditions = condition[logicalCombinationOperator];
    const childrenConditionExpressions = [];
    conditionParser.resetExpression();
    for (const childCondition of childrenConditions) {
        conditionParser.parse(childCondition);
        childrenConditionExpressions.push(conditionParser.expression);
    }
    conditionParser.resetExpression(`(${childrenConditionExpressions.join(`) ${logicalCombinationOperatorExpression[logicalCombinationOperator]} (`)})`);
};
exports.parseLogicalCombinationCondition = parseLogicalCombinationCondition;
